import { Struttura } from '@hm_app/@core/models/struttura';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Faq } from '@hm_app/@core/models/info';

@Injectable()
export class FaqsService {

    // Observable sources
    private faq = new BehaviorSubject<Faq>(null);

    // Observable streams
    faqObservable = this.faq.asObservable();

    // Service message commands
    passFaq(faq: Faq) {
        this.faq.next(faq);
        // console.log(this.faq)
    }
}
